module.exports = __webpack_public_path__ + "img/shield_6.7bee56ee.png";